import { render, staticRenderFns } from "./Pos_inventory_edit.vue?vue&type=template&id=96e4e7c6&scoped=true&"
import script from "./Pos_inventory_edit.vue?vue&type=script&lang=js&"
export * from "./Pos_inventory_edit.vue?vue&type=script&lang=js&"
import style0 from "./Pos_inventory_edit.vue?vue&type=style&index=0&id=96e4e7c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e4e7c6",
  null
  
)

export default component.exports